/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

import { Children, PureComponent } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITourStep from 'ui-shepherd-react/tour/UITourStep';
import UITourNextButton from 'ui-shepherd-react/button/UITourNextButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { DONE } from 'ui-shepherd-react/constants/TourStates';
import { TOUR_POPOVER_BOTTOM_MARGIN, TOUR_POPOVER_WIDTH_PX } from '../constants/UIConstants';
import { getOnboardingStep } from '../constants/Events';
// @ts-expect-error module not typed
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class NewFeatureTourStep extends PureComponent {
  constructor(props) {
    super(props);
    this.handleBeforeStart = this.handleBeforeStart.bind(this);
    this.handleSkipTour = this.handleSkipTour.bind(this);
    this.handleTourComplete = this.handleTourComplete.bind(this);
  }
  handleBeforeStart() {
    const {
      stepKey
    } = this.props;
    trackEvent(getOnboardingStep({
      action: 'tour step',
      stepName: stepKey
    }));
  }
  handleSkipTour() {
    const {
      stepKey
    } = this.props;
    trackEvent(getOnboardingStep({
      action: 'skipped tour',
      stepName: stepKey
    }));
    const tourContext = this.context;
    tourContext.tour.finish();
  }
  handleTourComplete() {
    trackEvent(getOnboardingStep({
      action: 'tour end',
      stepName: DONE
    }));
  }
  renderLastStepFooter() {
    return /*#__PURE__*/_jsx(UITourNextButton, {
      beforeNext: this.handleTourComplete,
      use: "primary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-thread-view.new-feature-onboarding.finishTour"
      })
    });
  }
  renderFooter() {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UITourNextButton, {
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.new-feature-onboarding.nextTip"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: this.handleSkipTour,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-thread-view.new-feature-onboarding.skipTour"
        })
      })]
    });
  }
  render() {
    const {
      stepKey,
      header,
      body,
      placement,
      width,
      children
    } = this.props;
    const tourContext = this.context;
    if (!tourContext.tour) {
      return children;
    }
    const {
      steps
    } = tourContext.tour.getConfig();
    const isLastStep = steps.indexOf(stepKey) === steps.length - 1;
    return /*#__PURE__*/_jsx(UITourStep, {
      beforeStart: this.handleBeforeStart,
      stepKey: stepKey,
      content: {
        header: /*#__PURE__*/_jsx("h4", {
          children: header
        }),
        body: /*#__PURE__*/_jsx(Paragraph, {
          marginBlockEnd: TOUR_POPOVER_BOTTOM_MARGIN,
          children: body
        }),
        footer: isLastStep ? this.renderLastStepFooter() : this.renderFooter()
      },
      placement: placement,
      width: width || TOUR_POPOVER_WIDTH_PX,
      children: /*#__PURE__*/_jsx("span", {
        children: Children.only(children)
      })
    });
  }
}
NewFeatureTourStep.displayName = 'NewFeatureTourStep';